export default class DefaultRun {
  execute() {
    textArea.autoSize()
    productStock.onBeforeUnload()
  }
}
